module.exports = __webpack_public_path__ + "static/logos/snow-icon-f66b285512d73bc80a0970f6569b3e16.svg";